import React from "react";
import { RoutineOverviewView } from "components/Routines/RoutineOverviewView";

export const RoutineOverviewScreen = ({ route }) => {
  const { routineId, profileView } = route.params;
  return (
    <RoutineOverviewView routineId={routineId} profileView={profileView} />
  );
};
